import { BlockConfigurationObject } from "../../../interfaces/block-configuration-object.interface";

/* @ngInject */
function teamIconDirective(configurationObject: BlockConfigurationObject, cdnDomain: string): Record<string, any> {
	return {
		restrict: "A",
		scope: {
			sportCode: "=teamIconSport",
			teamObject: "=teamIconObject",
		},
		link: function (scope, element, attrs) {

			function applySrc() {
				if (scope.sportCode && scope.teamObject && scope.teamObject.Abv) {
					if (configurationObject.teamLogoDefault === "custom") {
						if (configurationObject.customTeamLogoFunction) {
							const sourceUrl = configurationObject.customTeamLogoFunction(scope.teamObject, scope.sportCode);
							if (sourceUrl) {
								attrs.$set("src", sourceUrl);
	
								// prevent loop of directive call after image has been loaded
								element.removeAttr("team-icon-sport");
							} else {
								console.log("team-icon directive failed - team logo function failed for sport/team pair " + scope.sportCode + " and " + scope.teamObject);
							}
							
						} else if (configurationObject.customTeamLogoList) {
							if (Object.keys(configurationObject.customTeamLogoList).includes(scope.sportCode.toUpperCase())
								&& Object.keys(configurationObject.customTeamLogoList[scope.sportCode.toUpperCase()]).includes(scope.teamObject.Abv)) {
	
								attrs.$set("src", configurationObject.customTeamLogoList[scope.sportCode.toUpperCase()][scope.teamObject.Abv]);
	
								// prevent loop of directive call after image has been loaded
								element.removeAttr("team-icon-sport");
							} else {
								console.log("team-icon directive failed - team logo function failed for sport/team pair " + scope.sportCode + " and " + scope.teamObject);
							}
						} else if (configurationObject.customTeamLogoStructure) {
							// TODO implement customTeamLogoStructure logic
						}
					} else if (configurationObject.teamLogoDefault === "generic") {
						if (scope.sportCode.toLowerCase() === "bbl") {
							attrs.$set("src", `${cdnDomain}/images/${scope.sportCode.toLowerCase()}/${scope.teamObject.DisplayName}.svg`);
						} else {
							attrs.$set("src", `${cdnDomain}/images/${scope.sportCode.toLowerCase()}/${scope.teamObject.Abv}.${["swc", "euro"].includes(scope.sportCode.toLowerCase()) ? "png" : "svg"}`);
						}
	
						// prevent loop of directive call after image has been loaded
						element.removeAttr("team-icon-sport");
					} else {
						if (scope.sportCode.toLowerCase() === "bbl") {
							attrs.$set("src", `${cdnDomain}/images/${scope.sportCode.toLowerCase()}/official/${scope.teamObject.DisplayName}.svg`);
						} else {
							attrs.$set("src", `${cdnDomain}/images/${scope.sportCode.toLowerCase()}/official/${scope.teamObject.Abv.toUpperCase()}.svg`);
						}
	
						// prevent loop of directive call after image has been loaded
						element.removeAttr("team-icon-sport");
					}
				} else {
					// TODO throw some sort of error
					console.log("team-icon directive failed - invalid sport/team pair " + scope.sportCode + " and " + JSON.stringify(scope.teamObject));
				}
			}

			applySrc();
			// element.addClass('dummy').removeClass('dummy');
			// console.log('doing dummy stuff again at the end')
			scope.$watch("teamObject.Abv", applySrc);
		}
	};
}

export default teamIconDirective;